import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_ENDPOINT,
    headers: { 'Authorization': process.env.REACT_APP_TOKEN }
});

export default api;